import type { ReactNode } from "react";
import type { TreeNodeData } from "../../Tree/types";

interface FieldNameMapping {
  label?: string;
  value?: string;
}

export const resolveFieldNames = (
  nodes: TreeNodeData[],
  fieldNames: FieldNameMapping
): TreeNodeData[] => {
  const labelKey = fieldNames.label ?? "title";
  const valueKey = fieldNames.value ?? "key";

  const remap = (items: TreeNodeData[]): TreeNodeData[] =>
    items.map(item => {
      const record = item as unknown as Record<string, unknown>;

      return {
        key: String(record[valueKey] ?? ""),
        title: record[labelKey] as ReactNode,
        disabled: record.disabled as boolean | undefined,
        children: Array.isArray(item.children)
          ? remap(item.children)
          : undefined,
      };
    });

  return remap(nodes);
};
